export class AccountCardVariant {
  static ICON = 'ICON'
  static TEXT = 'TEXT'
  static TEXT_ICON = 'TEXT_ICON'
  static ICON_TEXT = 'ICON_TEXT'
  static ICON_TEXT_UNDER = 'ICON_TEXT_UNDER'
}
